<template>
    <client-page>

        <sub-visual
        sh="Distributor in Korea"
        tabActive="ENDO Metal-Sleeve"
        bg="/images/sub/visual/sv3.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <h2 class="page-tit mb-lg-42">
                    ENDO Metal-Sleeve
                </h2>
            </v-container>

            <sub-bg-image
            src="/images/sub/distributor/endo/endo-top-img.png"
            className="h-lg-340px">
                <h3 class="tit font-weight-semibold mb-8 mb-md-50 mb-lg-100">
                    ENDO 제작소의 MetalSleeve는 <br>
                    독자적으로 개발한 금속 소성가공기술을 <br>
                    적용한 Metal Sleeve입니다.
                </h3>
                <p class="page-text color-grey-51 mb-2 mb-lg-10">
                    Metal Sleeve는 엔도 제작소의 금속 소성 가공 기술의 <br class="d-none d-md-block">
                    진화에 의해 탄생 하였습니다.
                </p>
                <p class="page-text color-grey-51 mb-2 mb-lg-10">
                    연구를 거듭해 개발한 Metal Sleeve는 10μm 정도의 초박육 설계로, <br class="d-none d-md-block">
                    이음매가 없는 금속 가공하여, 고성능의 OA 기기에는 꼭 필요한 부품으로 <br class="d-none d-md-block">
                    큰 점유율을 차지하고 있습니다.
                </p>
                <p class="page-text color-grey-51">
                    환경산업과 의료산업 등 향후 성장이 기대되는 분야로 시야를 넓혀 <br class="d-none d-md-block">
                    독자적인 기술로 확실한 가치와 상품을 제공해 나갈 것입니다.
                </p>
            </sub-bg-image>

        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="특장점">
                    <v-row>
                        <icon-line-box
                        icon="/images/sub/distributor/endo/endo-icon1.png"
                        iconWidth="50"
                        num="01">
                        높은기술력은 정밀한 품질이 요구되는 제품의 고도화에 극대화
                        </icon-line-box>

                        <icon-line-box
                        icon="/images/sub/distributor/endo/endo-icon2.png"
                        iconWidth="50"
                        num="02">
                        고품질을 유지하면서 대량생산을 가능하게 하는 생산체제를 확립
                        </icon-line-box>

                        <icon-line-box
                        icon="/images/sub/distributor/endo/endo-icon3.png"
                        iconWidth="50"
                        num="03">
                        기술과 품질은 다양한업계에서 주목을 받고 <br class="d-none d-lg-block">
                        큰 잠재력을 가지고 있습니다.
                        </icon-line-box>

                        <icon-line-box
                        icon="/images/sub/distributor/endo/endo-icon4.png"
                        iconWidth="50"
                        num="04">
                        초박육의이음매가 없는 금속 가공을 가능하게 해, <br class="d-none d-lg-block">
                        고성능의 OA 기기에는 꼭 필요한 기능 부품
                        </icon-line-box>
                    </v-row>
                </sub-line-layout>
            </v-container>
        </section>

        <div class="sub-section">
            <v-container>

                <sub-line-layout
                tit="ENDO Metal-Sleeve"
                className="full">
                    <v-row class="my-n10 my-lg-n40">
                        <v-col cols="12" md="6" xl="4" class="py-10 py-lg-40">

                            <image-detail
                            src="/images/sub/distributor/endo/endo-img3-1.png">

                                <h5 class="tit--sm font-weight-medium">
                                    Ultra-Thin Seamless Pipe
                                </h5>

                                <p class="font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail">
                                    판 두께 40μm 이하의 초박육 가공을 실현함으로써, <br class="d-none d-lg-block">
                                    수지필름과 같이 슬리브를 구부려 사용하는것이 <br class="d-none d-lg-block">
                                    가능해집니다. 내열성, 내식성, 내마모성, 강성이 우수합니다.
                                </p>

                                <standard
                                diameter="φ18mm에서 φ45mm까지"
                                weight="27μm에서 100μm까지"
                                length="420mm까지">
                                </standard>

                            </image-detail>

                        </v-col>

                        <v-col cols="12" md="6" xl="4" class="py-10 py-lg-40">

                            <image-detail
                            src="/images/sub/distributor/endo/endo-img3-2.png">

                                <h5 class="tit--sm font-weight-medium">
                                    Thin Seamless Pipe
                                </h5>

                                <p class="font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail">
                                    타공법에서는 실현 곤란한 판 두께 100μm 이하의 <br class="d-none d-lg-block">
                                    얇은 가공을 실현, 내열 강도나 내식성을 갖춘 얇은 <br class="d-none d-lg-block">
                                    이음매 없는 파이프로서 사용하고 있습니다.
                                </p>

                                <standard
                                diameter="φ10mm에서 φ30mm까지"
                                weight="100μm에서 300μm까지"
                                length="420mm까지">
                                </standard>

                            </image-detail>

                        </v-col>

                        <v-col cols="12" md="6" xl="4" class="py-10 py-lg-40">

                            <image-detail
                            src="/images/sub/distributor/endo/endo-img3-3.png">

                                <h5 class="tit--sm font-weight-medium">
                                    Ultra-Thin Seamless Belt
                                </h5>

                                <p class="font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail">
                                    내열성, 내식성이 우수하고, 또한 피로 강도를 향상시키는 <br class="d-none d-lg-block">
                                    처방을 실시함으로써 구동 전달용 벨트의 기재로서 <br class="d-none d-lg-block">
                                    우수한 특성을 나타내고 있습니다.
                                </p>

                                <standard
                                diameter="φ20mm에서 φ160mm까지"
                                weight="15μm에서 60μm까지"
                                length="3mm에서 400mm까지">
                                </standard>

                            </image-detail>

                        </v-col>

                        <v-col cols="12" md="6" xl="4" class="py-10 py-lg-40">

                            <image-detail
                            src="/images/sub/distributor/endo/endo-img3-4.png">

                                <h5 class="tit--sm font-weight-medium">
                                    Small Diameter, <br class="d-none d-xl-block">
                                    Ultra-Thin Seamless Ring
                                </h5>

                                <p class="font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail">
                                    소경・박육 용도로의 심리스 링이 됩니다.  <br>
                                    최소 직경으로 φ3, 최소 두께로 t15μm를 <br class="d-none d-lg-block">
                                    실현하고 있어 의료 기기의 부품으로서 
                                    검토 되고 있습니다.
                                </p>

                                <standard
                                diameter="φ3mm에서 φ30mm까지"
                                weight="15μm에서 60μm까지"
                                length="3mm에서">
                                </standard>

                            </image-detail>

                        </v-col>

                        <v-col cols="12" md="6" xl="4" class="py-10 py-lg-40">

                            <image-detail
                            src="/images/sub/distributor/endo/endo-img3-5.png">

                                <h5 class="tit--sm font-weight-medium">
                                    Small Diamete, Ultra-Thin <br class="d-none d-xl-block">
                                    Seamless Pipe
                                </h5>

                                <p class="font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail">
                                    소경・박육 용도로의 이음매없는 파이프가 됩니다. <br>
                                    최소 직경으로 φ3, 최소 두께로 t15μm를 실현하고 있어 <br class="d-none d-lg-block">
                                    전기기기, 의료 기기, 자동차의 부품으로서 
                                    검토 되고 있습니다.
                                </p>

                                <standard
                                diameter="φ3mm에서 φ10mm까지"
                                weight="15μm에서 100μm까지"
                                length="400mm까지">
                                </standard>

                            </image-detail>

                        </v-col>

                        <v-col cols="12" md="6" xl="4" class="py-10 py-lg-40">

                            <image-detail
                            src="/images/sub/distributor/endo/endo-img3-6.png">

                                <h5 class="tit--sm font-weight-medium">
                                    Seamless Case <br class="d-none d-xl-block">
                                    with Bottom
                                </h5>

                                <p class="font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail">
                                    바닥부・원통부에 용접부가 없기 때문에 내식성이 <br class="d-none d-lg-block">
                                    우수하고, 엄격한 사용 환경에 있어서 뛰어난 특성을 <br class="d-none d-lg-block">
                                    건전지 케이스로 제작될 만큼 
                                    활용도가 넓습니다.
                                </p>

                                <standard
                                diameter="φ20mm에서 φ60mm까지"
                                weight="50μm에서 300μm까지"
                                length="50mm에서 400mm까지">
                                </standard>

                            </image-detail>

                        </v-col>
                    </v-row>
                </sub-line-layout>

            </v-container>
        </div>

        <div class="sub-section sub-section--last">
            <v-container>

                <inquiry
                src="/images/sub/distributor/endo/endo-img1.png"
                name="황 정호"
                tel="031-765-2268"
                mail="hwangjoe@ist-co.kr"
                fax="031-765-2389"
                link="http://endo-mfg.co.jp/eng/"
                linkBg="/images/sub/distributor/endo/endo-img2.png">
                </inquiry>

            </v-container>
        </div>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubLineLayout from "@/components/client/ko/sub/sub-line-layout.vue";
import SubBgImage from "@/components/client/ko/sub/sub-bg-image.vue";
import IconLineBox from "@/components/client/ko/sub/sub-icon-line-box.vue";
import Inquiry from "@/components/client/ko/sub/sub-inquiry.vue";
import ImageDetail from "@/components/client/ko/sub/sub-image-detail.vue";
import Standard from "@/components/client/ko/sub/sub-standard.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubLineLayout,
        SubBgImage,
        IconLineBox,
        Inquiry,
        ImageDetail,
        Standard,
    },
};
</script>

<style lang="scss" scoped>
</style>